import React from 'react';
import properties from '../../constants/Properties';
import modeType from '../../constants/ModeConstants';
import storeManager from '../../store/StoreManager';
import { changeContextMode } from '../../actions/MenuActions';
import { CustomSlider } from './CustomSlider';
import locales from '../../locales/LocalesManager';
import appParameters from '../../components/utils/AppParameters';
import platformDetection from '../utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        var closeButtonStyle = {
            position: 'absolute',
            right: 28,
            top: 4,
            width: 22,
            height: 22,
            cursor: 'pointer',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            background: 'none',
            borderStyle: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            right: 3,
            cursor: 'pointer'
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('BackgroundVisibilityMenuTitle', 'stylingMenu')}</span>

                <button id="firstFocusableObjectForBackgroundVisibilityMenu" style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

export const BackgroundVisibilityMenu = React.createClass({
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObjectForBackgroundVisibilityMenu');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    shouldComponentUpdate(newProps) {
        if (this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.contextTarget != newProps.contextTarget || this.props.contextMode != newProps.contextMode || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.contextMode != modeType.SLIDE_VISIBILITY)
            return <div/>;

        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            cursor: 'default'
        };

        var opacityProperties = {};
        opacityProperties.topPosition = 50;
        opacityProperties.leftPosition = properties.BROWSER_LEFT_PADDING;
        opacityProperties.width = properties.BROWSER_WIDTH - 2 * properties.BROWSER_LEFT_PADDING;
        opacityProperties.height = properties.STYLING_SLIDER_HEIGHT;
        opacityProperties.backgroundHref = appParameters.RESOURCES_LOCATION() + 'assets/opacitySlider.png';
        opacityProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        opacityProperties.thumbSize = properties.STYLING_THUMB_SIZE;
        opacityProperties.start = 1;
        opacityProperties.end = 0;
        opacityProperties.step = 0.1;
        opacityProperties.target = storeManager.getState().currentSlide.model.content[0];
        opacityProperties.dispatch = this.props.dispatch;
        opacityProperties.type = 'change_opacity';

        return (
            <div style={menuStyle} id="backgroundVisibilityMenu">
                <Title accordionWidth={this.props.accordionWidth}/>
                <CustomSlider properties={opacityProperties} id='lastFocusableObjectForBackgroundVisibilityMenu'/>
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/BackgroundVisibilityMenu.js
 **/